export const ID_USERTYPE = {
  1: 'sender',
  2: 'receiver',
};

export default {};
